import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    Insured.custom_upload_init()
  }

  async deleteDocument(event) {
    event.preventDefault()
    const link = event.currentTarget
    
    if (!confirm("Are you sure you want to remove this document?")) {
      return
    }

    try {
      await fetch(link.href, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': this.getCsrfToken(),
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
    } finally {
      window.location.reload()
    }
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.content : ''
  }
}
